module.exports = __webpack_public_path__ + "img/registration_illustration.e1bb8059.png";